export const createCompanySlice = (set, get) => ({
  company: {
    data: null,
    loading: false,
    error: "",
    fetchedCompanyIds: [],
  },
  companyActions: {
    setLoading: (loading) =>
      set((state) => {
        state.company.loading = loading;
      }),
    setData: (data) =>
      set((state) => {
        state.company.data = data;
      }),
    setError: (error) =>
      set((state) => {
        state.company.error = error;
      }),
    markCompanyAsFetched: (companyId) =>
      set((state) => {
        if (!state.company.fetchedCompanyIds.includes(companyId)) {
          state.company.fetchedCompanyIds.push(companyId);
        }
      }),
    isCompanyFetched: (companyId) => {
      const state = get();
      return state.company.fetchedCompanyIds.includes(companyId);
    },
  },
});
